import { deleteChatApi, getChatApi, getChatsApi } from "@/apis/chat";
import { DeleteApiClient, GetApiClient } from "@/utils/api-client";

export class ChatUsecase {
  static histories(apiClient: GetApiClient) {
    return getChatsApi(apiClient);
  }

  static chat(apiClient: GetApiClient, id: string) {
    return getChatApi(apiClient, id);
  }

  static deleteChat(apiClient: DeleteApiClient, id: string) {
    return deleteChatApi(apiClient, id);
  }
}
